export function normalizeMapEmbed(input: unknown = ''): string {
    let value = String(input || '').trim();
    if (!value) return '';

    const iframeSrc = value.match(/<iframe[^>]*\s+src=["']([^"']+)["'][^>]*>/i);
    if (iframeSrc) value = iframeSrc[1];

    const looseSrc = value.match(/\bsrc=["']([^"']+)["']/i);
    if (looseSrc) value = looseSrc[1];

    const anyUrl = value.match(/https?:\/\/[^\s"'<>]+/i);
    if (anyUrl) value = anyUrl[0];

    value = value.replace(/&amp;/gi, '&');

    try {
        const normalizedUrl = new URL(value);
        const host = normalizedUrl.hostname.replace(/^www\./, '');

        if (!/(^|\.)google\.com$/i.test(host)) return '';

        if (normalizedUrl.pathname.includes('/maps/embed')) {
            const pb = (normalizedUrl.search.match(/[?&]pb=([^&#]+)/) || [])[1];
            return pb ? `https://www.google.com/maps/embed?pb=${pb}` : value;
        }

        const pb = (normalizedUrl.search.match(/[?&]pb=([^&#]+)/) || [])[1];
        if (pb) {
            return `https://www.google.com/maps/embed?pb=${pb}`;
        }

        return '';
    } catch {
        return '';
    }
}
